__turbopack_context__.v({
  "className": "plus_jakarta_sans_e91b7c41-module__4Z80HW__className",
});
